import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [outSideCompany, setOutSideCompany] = useState([]);
  const [loading, setLoading] = useState(false);

  // const fetchData = () => {
  //   Http.get("/distributor").then((res) => {
  //     setReceiveData(res.data);
  //   });
  //   Http.get("/me").then((res) => {
  //     setOutSideCompany(res.data);
  //   });
  // };

  const fetchData = async () => {
    setLoading(true);
    try {
      const userResponse = await Http.get("/me");
      setOutSideCompany(userResponse.data);

      const distributorResponse = await Http.get("/distributor");
      setReceiveData(distributorResponse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Ensure loading is false after fetch
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };

  const cols = [
    { field: "code", header: "Code" },
    { field: "name", header: "Name" },

    { field: "email", header: "Email" },
    ...(outSideCompany?.data?.user_type !== "other-company"
      ? [
          {
            header: "Detail",
            field: (rowData) => {
              return (
                <Link
                  to={`/distributor-details/${rowData.id}`}
                  className="btn btn-info btn-sm mx-1"
                  title="View"
                >
                  <i className="fa fa-list" aria-hidden="true"></i>
                </Link>
              );
            },
          },
          { field: "locationFound", header: "Location" },
          { field: "factory.name", header: "Depot" },
          { field: "usersMDO", header: "MDO" },
          { field: "usersDSR", header: "DSR" },
          { field: "usersAM", header: "AM" },
          { field: "usersRSM", header: "RSM" },
          { field: "baseNames", header: "Base" },
          { field: "areaNames", header: "Area" },
          { field: "regionNames", header: "Region" },
          { field: "business_type", header: "Type" },
        ]
      : []),

    { field: "balance", header: "Balance" },
    { field: "status", header: "Status" },
  ];

  const mappedData = receiveData.map((item) => {
    const baseNames = item.sr_base_info
      .map((info) => info.base?.name)
      .join(" , ");
    const areaNames = item.distributor_workplace
      .map((info) => info.area?.name)
      .join(" , ");
    const regionNames = item.distributor_workplace
      .map((info) => info.region?.name)
      .join(" , ");

    // Initialize usersByType
    const usersByType = {
      so: [],
      dsr: [],
      am: [],
      rsm: [],
    };

    item.sr_base_info.forEach((info) => {
      if (info.base && info.base.users) {
        info.base.users.forEach((user) => {
          // Ensure user_type exists before pushing
          if (user.user_type && usersByType[user.user_type]) {
            usersByType[user.user_type].push(`${user.name}`);
          }
        });
      }
    });

    // Create separate fields for each user type
    const usersMDO = usersByType["so"].join(" ||  ");
    const usersDSR = usersByType["dsr"].join(" || ");
    const usersAM = usersByType["am"].join(" || ");
    const usersRSM = usersByType["rsm"].join(" || ");

    return {
      ...item,
      baseNames,
      areaNames,
      regionNames,
      usersMDO,
      usersDSR,
      usersAM,
      usersRSM,
    };
  });

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Distributors</h5>
            <Link to="/create-distributors" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i>New
            </Link>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card">
              <ReactDataTable
                cols={cols}
                receiveData={mappedData}
                // imageBodyTemplate={imageBodyTemplate}
                actionTemplate={actionTemplate}
                // detailOnName={detailOnName}
                deleteData={deleteData}
                // statusChange={statusChange}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const actionTemplate = (rowData, deleteData, statusChange, outSideCompany) => {
  return (
    <div className="text-xs text-nowrap">
      {/* <Link
        to={{
          pathname: "/edit-shop/" + rowData.id,
          state: { id: rowData.id },
        }}
        className="btn btn-primary btn-sm"
        title="Edit"
      >
        <i className="fa fa-pencil" aria-hidden="true"></i>
      </Link> */}
      <Link
        to={{
          pathname: "/edit-distributors/" + rowData.id,
        }}
        className="btn btn-primary btn-sm ml-1"
      >
        <i className="fa fa-pencil" aria-hidden="true"></i>
      </Link>
      {/* <button
        className="btn btn-danger btn-sm ms-1"
        onClick={() => deleteData(rowData.id, "distributors", "distributors")}
        title="Delete"
      >
        <i className="fa fa-trash"></i>
      </button> */}
      <Link
        to={{ pathname: "/distributor-details/" + rowData.id }}
        className="btn btn-info btn-sm mx-1"
        title="View"
      >
        <i className="fa fa-list" aria-hidden="true"></i>
      </Link>
      {outSideCompany?.data?.user_type !== "other-company" && (
        <Link
          to={{
            pathname: "/create-place-plan/" + rowData.id,
          }}
          className="btn btn-success btn-sm mr-1"
        >
          <i className="fa fa-map-marker" aria-hidden="true"></i>
        </Link>
      )}
      {/* <button
        className="btn btn-primary btn-sm ms-1"
        onClick={() => statusChange(rowData.id, "shop-status", "shop")}
        title="Active Inactive"
      >
        <i className="fa fa-link"></i>
      </button> */}
    </div>
  );
};
// const detailOnName = (rowData) => {
//   return (
//     <div className="text-xs text-nowrap">

//       <Link
//         to={{
//           pathname: "/distributor-details/" + rowData.id,
//         }}
//         title="Distributor Details"
//       >
//         {rowData.name}
//       </Link>
//     </div>
//   );
// };

export default List;
